/**
 * Browser stand-in for the one `node:crypto` symbol packages/client imports.
 * Aliased in vite.config.ts. See that file for why the alias exists rather
 * than a change to packages/client.
 */
export function randomUUID(): string {
  return globalThis.crypto.randomUUID();
}
